import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { FOOTER_QUICK_LINKS, FOOTER_EXPORT_LINKS } from '../data/homeData';

const SOCIAL_ICONS = [
  {
    label: 'Instagram',
    path: (
      <>
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
      </>
    ),
  },
  {
    label: 'Facebook',
    path: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
  },
  {
    label: 'LinkedIn',
    path: (
      <>
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect width="4" height="12" x="2" y="9" />
        <circle cx="4" cy="4" r="2" />
      </>
    ),
  },
];

function Footer() {
  return (
    <footer className="site-footer" id="sustainability">
      <svg className="footer-wave" viewBox="0 0 1200 60" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,40 C200,10 400,50 600,30 C800,10 1000,50 1200,30 L1200,0 L0,0 Z" fill="currentColor" />
      </svg>

      <div className="footer-blob footer-blob-r" />
      <div className="footer-blob footer-blob-l" />

      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand reveal">
            <Link to="/" className="footer-logo" aria-label="Swarvinn Impex Ltd — Home">
              <img
                src="/images/logo-header.png"
                alt=""
                className="footer-logo-img"
                aria-hidden="true"
              />
              <span className="footer-logo-text">
                <span className="footer-logo-name">Swarvinn</span>
                <span className="footer-logo-sub">Impex Ltd</span>
              </span>
            </Link>
            <p className="footer-desc">
              Swarvinn Impex exports authentic Indian rice, spices, pulses, millets,
              flours, and oils from Tamil Nadu. Our main export country is the United Kingdom,
              with secondary supply to Europe, the UAE &amp; Middle East, USA, Canada,
              Australia, and Singapore.
            </p>
            <div className="footer-social">
              {SOCIAL_ICONS.map((icon) => (
                <a key={icon.label} href="#social" aria-label={icon.label}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    {icon.path}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col reveal">
            <h4>Quick Links</h4>
            <ul>
              {FOOTER_QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.href}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col reveal">
            <h4>Export Markets</h4>
            <ul>
              {FOOTER_EXPORT_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.href}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col reveal">
            <h4>Contact Details</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={16} />
                <span>
                  Swarvinn Impex, Export Division<br />
                  Tamil Nadu, India · Main market: United Kingdom
                </span>
              </li>
              <li>
                <Phone size={16} />
                <a href="tel:+914422345678">+91 442 234 5678</a>
              </li>
              <li>
                <Mail size={16} />
                <a href="mailto:export@swarvinnimpex.com">export@swarvinnimpex.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Swarvinn Impex. All rights reserved.</p>
          <p className="footer-est">EST · MCMLXXVIII</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
